import React, { Component } from 'react';
import { Layout, Menu, LocaleProvider } from 'antd';
import { inject } from 'mobx-react';
import { Router, Switch, Route, Redirect, Link } from 'react-router-dom';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import { Provider } from 'mobx-react';
import LoginStore from '../store/Login.js';
import AppFirmwareStore from '@/store/AppFirmware/AppFirmware';
import AppFileStore from '@/store/AppFile/AppFile';
import TrafficReportStore from '../store/TrafficReport/TrafficReport';
import ReportStore from '../store/Report/Report';
import OTAStore from '../store/OTA/OTA';
import DeviceInfoStore from '../store/DeviceInfo/DeviceInfo';
import DeviceInfoAppStore from '../store/DeviceInfo/DeviceApp';
import DeviceInfoDetailStore from '../store/DeviceInfo/DeviceDetail';
import DeviceInfoMonitorStore from '../store/DeviceInfo/DeviceMonitor';
import DeviceInfoControlStore from '../store/DeviceInfo/DeviceControl';
import DeviceInfoConnectStore from '../store/DeviceInfo/DeviceConnect';
import StatisticsStore from '../store/Statistics/Statistics';
import StatisticsResourceStore from '../store/Statistics/StatisticsResource';
import StatisticsMapStore from '../store/Statistics/StatisticsMap';
import DeviceGroupStore from '../store/DeviceGroup/DeviceGroup';
import GlobalStore from '../store/Global';
import AddGroupStore from '../store/DeviceGroup/AddGroup';
import AppStrategyStore from '../store/AppStrategy/AppStrategy';
import DeviceConfigStore from '../store/DeviceConfig/DeviceConfig';
import OnOfflineStore from '../store/DeviceInfo/OnOffline';
import history from '@/lib/history';
import Login from '@/pages/Login/Login';
import Statistics from '@/pages/Statistics/Statistics';
import Report from '@/pages/Report/Report';
import TrafficReport from '@/pages/TrafficReport/TrafficReport';
import DeviceInfo from '@/pages/DeviceInfo/DeviceInfo';
import DeviceGroup from '@/pages/DeviceGroup/DeviceGroup';
import DeviceConfig from '../pages/DeviceConfig/DeviceConfig';
import DeviceOTA from '@/pages/OTA/OTA';
import DeviceFactory from '@/pages/DeviceInfo/DeviceFactory';
import AppFile from '@/pages/AppFile/AppFile';
import AppStrategy from '@/pages/AppStrategy/AppStrategy';
import AppFirmware from '@/pages/AppFirmware/AppFirmware';
import AddGroup from '@/pages/DeviceGroup/AddGroup';
import { filterByAuth } from '../const/Menu';
import Cookies from 'js-cookie';
import Loading from '@/components/Loading';
import './App.css';
import zh_CN from 'antd/es/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

const stores = {
  globalStore: GlobalStore,
  loginStore: LoginStore,
  appFirmwareStore: AppFirmwareStore,
  appFileStore: AppFileStore,
  trafficReportStore: TrafficReportStore,
  reportStore: ReportStore,
  otaStore: OTAStore,
  deviceInfoStore: DeviceInfoStore,
  deviceInfoAppStore: DeviceInfoAppStore,
  deviceInfoDetailStore: DeviceInfoDetailStore,
  deviceInfoMonitorStore: DeviceInfoMonitorStore,
  deviceInfoControlStore: DeviceInfoControlStore,
  deviceInfoConnectStore: DeviceInfoConnectStore,
  statisticsStore: StatisticsStore,
  statisticsResourceStore: StatisticsResourceStore,
  statisticsMapStore: StatisticsMapStore,
  deviceGroupStore: DeviceGroupStore,
  addGroupStore: AddGroupStore,
  appStrategyStore: AppStrategyStore,
  deviceConfigStore: DeviceConfigStore,
  onOfflineStore: OnOfflineStore
};

const DefaultLayout = ({ component: Component, authority, ...rest }) => {
  const pathname = rest.location.pathname;
  const menus = filterByAuth(authority);
  return (
    <Layout>
      <Header />
      <Layout
        style={{ height: '100%', minHeight: 'calc(100vh - 60px - 30px)' }}
      >
        <Sider width={260}>
          <Menu
            mode="inline"
            theme="dark"
            defaultOpenKeys={pathname
              .split('/')
              .filter(i => !!i)
              .slice(0, 1)}
            selectedKeys={[pathname]}
          >
            {menus.map(item => (
              <SubMenu key={item.name} title={<span>{item.title}</span>}>
                {item.child.map(a => (
                  <Menu.Item key={`/${item.name}/${a.name}`}>
                    <Link to={`/${item.name}/${a.name}`}>{a.label}</Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            ))}
          </Menu>
        </Sider>
        <Layout>
          <Component {...rest} />
        </Layout>
      </Layout>
      <Footer />
    </Layout>
  );
};

@inject('loginStore')
class AuthController extends Component {
  state = {
    isAuthed: false,
    loading: true
  };

  componentDidMount() {
    const { loginStore } = this.props;
    if (Cookies.get('token') && loginStore.userId) {
      this.setState({
        isAuthed: true,
        loading: false
      });
    } else if (Cookies.get('token')) {
      const cb = () =>
        this.setState({
          isAuthed: true,
          loading: false
        });
      loginStore.self(cb);
    } else {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    const { loginStore, ...rest } = this.props;
    const { isAuthed, loading } = this.state;
    if (loading) {
      return <Loading loadingTip="初始化中..." />;
    }
    if (!isAuthed) {
      return <Redirect to="/login" />;
    }
    return <DefaultLayout authority={loginStore.authority} {...rest} />;
  }
}

class App extends Component {
  render() {
    return (
      <LocaleProvider locale={zh_CN}>
        <Provider {...stores}>
          <Router history={history}>
            <Switch>
              <Route
                path="/login"
                exact
                render={props => (
                  <Layout>
                    <Header />
                    <Login {...props} />
                    <Footer />
                  </Layout>
                )}
              />
              <Route
                path="/"
                exact
                render={() => <Redirect to="/status/statistics" />}
              />
              <Route
                path="/status/statistics"
                exact
                render={props => (
                  <AuthController component={Statistics} {...props} />
                )}
              />
              <Route
                path="/status/report"
                exact
                render={props => (
                  <AuthController component={Report} {...props} />
                )}
              />
              <Route
                path="/status/trafficReport"
                exact
                render={props => (
                  <AuthController component={TrafficReport} {...props} />
                )}
              />
              <Route
                path="/device/info/:id"
                exact
                render={props => (
                  <AuthController component={DeviceInfo} {...props} />
                )}
              />
              <Route
                path="/device/info"
                exact
                render={props => (
                  <AuthController component={DeviceInfo} {...props} />
                )}
              />
              <Route
                path="/device/group"
                exact
                render={props => (
                  <AuthController component={DeviceGroup} {...props} />
                )}
              />
              <Route
                path="/device/addGroup/group"
                exact
                render={props => (
                  <AuthController component={AddGroup} {...props} />
                )}
              />
              <Route
                path="/device/config"
                exact
                render={props => (
                  <AuthController component={DeviceConfig} {...props} />
                )}
              />
              <Route
                path="/device/OTA"
                exact
                render={props => (
                  <AuthController component={DeviceOTA} {...props} />
                )}
              />
              <Route
                path="/device/factory"
                exact
                render={props => (
                  <AuthController component={DeviceFactory} {...props} />
                )}
              />
              <Route
                path="/app/file"
                exact
                render={props => (
                  <AuthController component={AppFile} {...props} />
                )}
              />
              <Route
                path="/app/strategy"
                exact
                render={props => (
                  <AuthController component={AppStrategy} {...props} />
                )}
              />
              <Route
                path="/app/firmware"
                exact
                render={props => (
                  <AuthController component={AppFirmware} {...props} />
                )}
              />
            </Switch>
          </Router>
        </Provider>
      </LocaleProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js